export default __webpack_public_path__ + "static/media/screen4.27d551d8.png";